<template>
    <SettingsLayout>
        <Head :title="`${page_name} - Grundeinstellungen`" />

        <template #breadcrumb>{{ page_name }}</template>
        <template #controls>
            <HeaderLink class="mr-3" href="/" type="close"
                >Schließen</HeaderLink
            >
            <HeaderButton @click="submit()">Speichern</HeaderButton>
        </template>
        <Heading title="Allgemeine Öffnungszeiten" />

        <p class="max-w-2xl text-sm text-oteoText mb-9">
            Bitte geben Sie die Öffnungszeiten Ihrer Praxis an. Hierfür wählen
            Sie einfach die entsprechenden Tage und Uhrzeiten aus. Wenn Sie
            durchgängig geöffnet haben, tragen Sie die Zeitauswahl in die linke
            Spalte ein. Wenn Sie Mittagspause haben, wählen Sie Ihre
            Praxiszeiten vormittags und nachmittags aus.
        </p>

        <div class="">
            <OpeningTimeRow
                v-model:start="workingHours[0].start"
                v-model:end="workingHours[0].end"
                v-model:start_2="workingHours[0].start_2"
                v-model:end_2="workingHours[0].end_2"
                v-model:open="workingHours[0].open"
                v-model:hasBreak="workingHours[0].hasBreak"
                title="Montag"
            />
            <OpeningTimeRow
                v-model:start="workingHours[1].start"
                v-model:end="workingHours[1].end"
                v-model:start_2="workingHours[1].start_2"
                v-model:end_2="workingHours[1].end_2"
                v-model:open="workingHours[1].open"
                v-model:hasBreak="workingHours[1].hasBreak"
                title="Dienstag"
            />
            <OpeningTimeRow
                v-model:start="workingHours[2].start"
                v-model:end="workingHours[2].end"
                v-model:start_2="workingHours[2].start_2"
                v-model:end_2="workingHours[2].end_2"
                v-model:open="workingHours[2].open"
                v-model:hasBreak="workingHours[2].hasBreak"
                title="Mittwoch"
            />
            <OpeningTimeRow
                v-model:start="workingHours[3].start"
                v-model:end="workingHours[3].end"
                v-model:start_2="workingHours[3].start_2"
                v-model:end_2="workingHours[3].end_2"
                v-model:open="workingHours[3].open"
                v-model:hasBreak="workingHours[3].hasBreak"
                title="Donnerstag"
            />
            <OpeningTimeRow
                v-model:start="workingHours[4].start"
                v-model:end="workingHours[4].end"
                v-model:start_2="workingHours[4].start_2"
                v-model:end_2="workingHours[4].end_2"
                v-model:open="workingHours[4].open"
                v-model:hasBreak="workingHours[4].hasBreak"
                title="Freitag"
            />
            <OpeningTimeRow
                class="mt-10"
                v-model:start="workingHours[5].start"
                v-model:end="workingHours[5].end"
                v-model:start_2="workingHours[5].start_2"
                v-model:end_2="workingHours[5].end_2"
                v-model:open="workingHours[5].open"
                v-model:hasBreak="workingHours[5].hasBreak"
                title="Samstag"
            />
            <OpeningTimeRow
                v-model:start="workingHours[6].start"
                v-model:end="workingHours[6].end"
                v-model:start_2="workingHours[6].start_2"
                v-model:end_2="workingHours[6].end_2"
                v-model:open="workingHours[6].open"
                v-model:hasBreak="workingHours[6].hasBreak"
                title="Sonntag"
            />
        </div>
    </SettingsLayout>
</template>

<script setup>
const props = defineProps({
    errors: Object,
    data: Array,
});

const workingHours = ref({
    0: {
        start: props.data[0] ? props.data[0].start : null,
        end: props.data[0] ? props.data[0].end : null,
        start_2: props.data[0] ? props.data[0].start_2 : null,
        end_2: props.data[0] ? props.data[0].end_2 : null,
        open: props.data[0] ? !!props.data[0].open : null,
        hasBreak: props.data[0] ? !!props.data[0].hasBreak : null,
    },
    1: {
        start: props.data[1] ? props.data[1].start : null,
        end: props.data[1] ? props.data[1].end : null,
        start_2: props.data[1] ? props.data[1].start_2 : null,
        end_2: props.data[1] ? props.data[1].end_2 : null,
        open: props.data[1] ? !!props.data[1].open : null,
        hasBreak: props.data[1] ? !!props.data[1].hasBreak : null,
    },
    2: {
        start: props.data[2] ? props.data[2].start : null,
        end: props.data[2] ? props.data[2].end : null,
        start_2: props.data[2] ? props.data[2].start_2 : null,
        end_2: props.data[2] ? props.data[2].end_2 : null,
        open: props.data[2] ? !!props.data[2].open : null,
        hasBreak: props.data[2] ? !!props.data[2].hasBreak : null,
    },
    3: {
        start: props.data[3] ? props.data[3].start : null,
        end: props.data[3] ? props.data[3].end : null,
        start_2: props.data[3] ? props.data[3].start_2 : null,
        end_2: props.data[3] ? props.data[3].end_2 : null,
        open: props.data[3] ? !!props.data[3].open : null,
        hasBreak: props.data[3] ? !!props.data[3].hasBreak : null,
    },
    4: {
        start: props.data[4] ? props.data[4].start : null,
        end: props.data[4] ? props.data[4].end : null,
        start_2: props.data[4] ? props.data[4].start_2 : null,
        end_2: props.data[4] ? props.data[4].end_2 : null,
        open: props.data[4] ? !!props.data[4].open : null,
        hasBreak: props.data[4] ? !!props.data[4].hasBreak : null,
    },
    5: {
        start: props.data[5] ? props.data[5].start : null,
        end: props.data[5] ? props.data[5].end : null,
        start_2: props.data[5] ? props.data[5].start_2 : null,
        end_2: props.data[5] ? props.data[5].end_2 : null,
        open: props.data[5] ? !!props.data[5].open : null,
        hasBreak: props.data[5] ? !!props.data[5].hasBreak : null,
    },
    6: {
        start: props.data[6] ? props.data[6].start : null,
        end: props.data[6] ? props.data[6].end : null,
        start_2: props.data[6] ? props.data[6].start_2 : null,
        end_2: props.data[6] ? props.data[6].end_2 : null,
        open: props.data[6] ? !!props.data[6].open : null,
        hasBreak: props.data[6] ? !!props.data[6].hasBreak : null,
    },
});

const page_name = "Behandlungszeiten";
let dataChanged = false;
let saveBtnClicked = false;

function submit() {
    saveBtnClicked = true;
    Inertia.put("/workingHoursOffice", workingHours.value);
}

onMounted(() => {});
//onUnmounted(
//    Inertia.on("before", (e) => {
//        if (dataChanged && !saveBtnClicked) {
//            return confirm(
//                "Sie haben ungespeicherte Eingaben. Wollen Sie diese Seite wirklich verlassen?"
//            );
//        }
//    })
//);
watch(
    workingHours,
    (cur, old) => {
        dataChanged = true;
    },
    { deep: true }
);

const form = useForm({});
import OpeningTimeRow from "@/Components/Settings/TreatmentHours/OpeningTimeRow.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import HeaderButton from "@/Components/Settings/HeaderButton.vue";
import Heading from "@/Components/Settings/Heading.vue";
import { Head, useForm } from "@inertiajs/inertia-vue3";
import { ref, onMounted, onUnmounted, watch } from "vue";
import { Inertia } from "@inertiajs/inertia";
</script>
